import Vue from 'vue'
import global from '@/config/global'
import store from '@/store/index'
import VueRouter from 'vue-router'
import router from '@/router/index'
import ElementUI from 'element-ui';
import Vant from 'vant';
import 'vant/lib/index.css';
import PicZoom from 'vue-piczoom'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import i18n from './lang/lang'
import { routerLoading } from './config/index'
import 'default-passive-events';
import VueClipboard from 'vue-clipboard2'

const routeLoadingBus = new Vue()
// 解决路由重复跳转错误
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return routerPush.call(this, location).catch(err => { })
};
Vue.use(VueRouter)
Vue.use(PicZoom)
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(VueClipboard)
Vue.prototype.$global = global;
Vue.prototype.$routeLoadingBus = routeLoadingBus;
Vue.config.productionTip = false
new Vue({
  render: h => h(App),
  router,
  store,
  i18n,
}).$mount('#app')
//当进入一个页面是会触发导航守卫 router.beforeEach 事件
router.beforeEach((to, from, next) => {
  const publicPaths = ['/', '/service','/activity', '/register', '/forget', '/rtp']
  const loggedIn = store.getters['user/isLoggedIn']
  if (!loggedIn && !publicPaths.includes(to.path)) {
    routeLoadingBus.$emit('change', false)
    store.dispatch('user/setLoginDialog', true)
    next(false)
    return
  }

  if (routerLoading && to.fullPath !== from.fullPath) {
    routeLoadingBus.$emit('change', true)
  }

  // meta.roles reserved for future RBAC; no roles wired yet
  next()
})

router.afterEach(() => {
  if (!routerLoading) {
    return
  }

  window.setTimeout(() => {
    routeLoadingBus.$emit('change', false)
  }, 180)
})

router.onError(() => {
  routeLoadingBus.$emit('change', false)
})
